function _axis() {
  let that = this;
  let scale = this.__execs__.scale;
  let axisToggles = this.axis();
  let field = this.__execs__.field;

  let _axisScaleX = function (axisToggle) {
    axisToggle.field = field.x.field;
    let curAxis = that.axisDefault(scale.x, axisToggle);
    if (axisToggle.orient === 'bottom') curAxis.y(scale.y.range()[1]);
    if (field.x.interval && field.x.format) { 
      curAxis.tickFormat(field.x.format);
    }
    return curAxis;
  }

  let _axisScaleY = function (axisToggle) {
    axisToggle.field = field.y.field;
    let curAxis = that.axisDefault(scale.y, axisToggle);
    if (axisToggle.orient === 'right') curAxis.x(scale.x.range()[1]);
    if (field.y.interval && field.y.format) { 
      curAxis.tickFormat(field.y.format);
    }
    return curAxis;
  }

  let xAt = axisToggles.find( d => d.target === 'x');
  let yAt = axisToggles.find( d => d.target === 'y');
  if (xAt) {
    _axisScaleX(xAt);
  } 
  if (yAt) {
    _axisScaleY(yAt);
  }
  

  this.renderAxis();
}

export default _axis;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/xy-heatmap/_axis.js